import { pluralNumber } from "src/util/pluralNumber";

import { DeliveryRangeDto } from "../VariantTreeDto";

export type PluralForms = [string, string, string];

export type DeliveryUnitLabels = {
  day: PluralForms;
  hour: PluralForms;
};

export const formatDeliveryRange = (
  delivery: DeliveryRangeDto | undefined,
  labels: DeliveryUnitLabels,
): string | null => {
  if (!delivery) return null;

  const forms = delivery.unit === "hour" ? labels.hour : labels.day;

  const min = delivery.min ?? delivery.max;
  const max = delivery.max ?? delivery.min;

  if (!min || !max) return null;

  if (min === max) {
    return `${min} ${pluralNumber(min, forms)}`;
  }

  return `${min}-${max} ${pluralNumber(max, forms)}`;
};
